/**
 * Customer portal UI theme / branding surface.
 * Colors: ThemeTokens (CSS vars). Logos: static defaults; ThemeService overwrites from API.
 */
import { ThemeTokens } from './theme-tokens';

export { ThemeTokens };

/** Login, register, header, footer — maps to API asset_key `site`. */
const siteLogoFile = 'assets/saferoads-logo.png';
/**
 * Home hero static fallback (original home asset).
 * When API `home_letter` is set, home uses that URL instead.
 */
const homeLogoFile = 'assets/saferoads-logo(1).png';
/** Letters / correspondence static fallback when API `home_letter` is empty. */
const letterLogoFile = 'assets/SAFEROADSLOGOWSLOGAN.png';
const logoVersion = '2026-static';

export const AppTheme = {
  tokens: ThemeTokens,
  siteLogoFile,
  homeLogoFile,
  letterLogoFile,
  logoVersion,
  siteLogoSrc: `${siteLogoFile}?v=${logoVersion}`,
  /** Home page hero fallback. */
  homeLogoSrc: `${homeLogoFile}?v=${logoVersion}`,
  /** Letters / communication-history fallback. */
  homeLetterLogoSrc: `${letterLogoFile}?v=${logoVersion}`,
} as const;
